import { REDUX } from 'constants/'
import {
    VariableReducerTypeInitiator,
    VariableAction,
    VariableReducer,
    Variable
} from 'types/variable'

/**
 * Reducer para objeto variable
 * @param state
 * @param action
 */
const VariableReducers = (
    state = VariableReducerTypeInitiator,
    action: VariableAction
): VariableReducer => {
    switch (action.type) {
        case REDUX.reducers.GET_ALL_VARIABLES:
            return {
                ...state,
                variablesList: action.payload,
                variablesListContributingFactor: action.payload
                    .find((p: any) => p.label === 'Categorized Contributing Factor')
                    .choices.map((c: any) => ({
                        index: c.index,
                        label: c.label,
                        value: c.value
                    })),
                variablesListIncidentType: action.payload
                    .find((p: any) => p.label === 'Tipo do incidente:')
                    .choices.map((c: any) => ({
                        index: c.index,
                        label: c.label,
                        value: c.value
                    })),
                variablesListDamageLevel: action.payload
                    .find((p: any) => p.label === 'Classificação do incidente:')
                    //.find((p: any) => p.label === 'Grau do dano:')
                    .choices.map((c: any) => ({
                        index: c.index,
                        label: c.label,
                        value: c.value
                    })),
                variablesListNotificationType: action.payload
                    .find((p: any) => p.label === 'Tipo de Notificação')
                    .choices.map((c: any) => ({
                        index: c.index,
                        label: c.label,
                        value: c.value
                    })),
                variablesListNotificationTurn: action.payload
                    .find((p: any) => p.label === 'Turno da ocorrência')
                    .choices.map((c: any) => ({
                        index: c.index,
                        label: c.label,
                        value: c.value
                    })),
                variablesListPacientDocumentType: action.payload
                    .find((p: any) => p.label === 'Sobre o paciente')
                    .children
                    .find((p: any) => p.label === 'Tipo do documento')
                    .choices.map((c: any) => ({
                        index: c.index,
                        label: c.label,
                        value: c.value
                    })),
                variablesListPacientGender: action.payload
                    .find((p: any) => p.label === 'Sobre o paciente')
                    .children
                    .find((p: any) => p.label === 'Gênero do paciente')
                    .choices.map((c: any) => ({
                        index: c.index,
                        label: c.label,
                        value: c.value
                    })),
                variablesListOmsClassification: action.payload
                    .find((p: any) => p.label === 'Sobre o paciente')
                    .children
                    .find((p: any) => p.label === 'Classificação OMS')
                    .choices.map((c: any) => ({
                        index: c.index,
                        label: c.label,
                        value: c.value
                    })),
                variablesListNames: action.payload.map(
                    (variable: Variable) =>
                        variable['u_name' as keyof typeof variable]
                ),
                variablesListDataTable: action.payload.map(
                    (variable: Variable): [number] => [variable.index]
                ),
                error: false,
                loading: false
            } as VariableReducer
        case REDUX.reducers.ERROR_VARIABLES:
            return {
                ...state,
                variablesList: [],
                error: true,
                loading: false
            } as VariableReducer
        case REDUX.reducers.GET_ALL_VARIABLES_COUNT:
            return {
                ...state,
                variableAllCount: action.payload,
                error: true,//! IS THIS CORRECT?
                loading: false
            } as VariableReducer
        default:
            return state
    }
}

export default VariableReducers
